import React from 'react';
import { SectionWrapper } from './ui';
import { TerminalIcon, MailIcon, Share2Icon, BarChart3Icon, DollarSignIcon, LayoutDashboardIcon, CheckCircle2Icon, GiftIcon } from 'lucide-react';
export const ProductOverview = () => {
  const tomos = [{
    id: 'T01',
    title: 'Prompts',
    icon: <TerminalIcon size={20} data-id="element-245" />
  }, {
    id: 'T02',
    title: 'Comunicación',
    icon: <MailIcon size={20} data-id="element-246" />
  }, {
    id: 'T03',
    title: 'Contenido',
    icon: <Share2Icon size={20} data-id="element-247" />
  }, {
    id: 'T04',
    title: 'Análisis',
    icon: <BarChart3Icon size={20} data-id="element-248" />
  }, {
    id: 'T05',
    title: 'Ventas',
    icon: <DollarSignIcon size={20} data-id="element-249" />
  }, {
    id: 'T06',
    title: 'Proyectos',
    icon: <LayoutDashboardIcon size={20} data-id="element-250" />
  }];
  return <SectionWrapper className="bg-dark-bg text-center" data-id="element-251">
      <div className="inline-block bg-primary/10 border border-primary/30 rounded-full px-6 py-2 mb-6" data-id="element-252">
        <span className="text-primary font-bold" data-id="element-253">🤖 SUPERKIT IA™</span>
      </div>
      <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-254">
        6 Tomos + 6 Bonos · +480 páginas · Todo resuelto con Inteligencia
        Artificial.
      </h2>

      <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-4xl mx-auto mt-12" data-id="element-255">
        {tomos.map(t => <div key={t.id} className="flex items-center gap-2 bg-dark-card border border-dark-border px-4 py-3 rounded-xl shadow-lg hover:border-primary/50 transition-colors" data-id="element-256">
            <span className="text-primary font-mono font-bold" data-id="element-257">{t.id}</span>
            <span className="text-accent" data-id="element-258">{t.icon}</span>
            <span className="text-white font-medium" data-id="element-259">{t.title}</span>
          </div>)}
      </div>
    </SectionWrapper>;
};
export const Tomos = () => {
  const tomosData = [{
    num: 1,
    title: 'INGENIERÍA DE COMANDO (PROMPT MASTERY)',
    desc: 'El sistema completo para hablarle a la IA como un experto y obtener respuestas que realmente podés usar. La Plantilla Maestra de 6 Elementos que transforma cualquier pedido mediocre en un resultado extraordinario.',
    includes: 'Incluye: 50+ prompts maestros organizados por función, la Estructura Maestra de 6 Elementos, los 10 moldes listos para cualquier tarea profesional y los comandos de refinamiento.'
  }, {
    num: 2,
    title: 'COMUNICACIÓN BLINDADA (EL FIN DE LA BANDEJA LLENA)',
    desc: 'El sistema completo para que nunca más te quedes clavado frente a un mail o mensaje sin saber qué responder. Inbox Zero todos los días. Respuestas perfectas en segundos.',
    includes: 'Incluye: Sistema de gestión de bandeja, 30+ templates de respuesta, protocolo de clientes difíciles y respuestas automáticas para WhatsApp.'
  }, {
    num: 3,
    title: 'EL CREADOR MAGNÉTICO (CONTENIDO MULTIPLATAFORMA)',
    desc: 'El sistema que genera 3 meses de contenido en una tarde. Sin bloqueo creativo. Sin pantalla en blanco. Sin improvisación semana a semana.',
    includes: 'Incluye: Sistema de Alimentación, banco de 100 ganchos probados, adaptación por plataforma (Instagram, LinkedIn, Facebook) y Calendario de 90 días.'
  }, {
    num: 4,
    title: 'ANÁLISIS ESTRATÉGICO (DATOS, EXCEL Y FINANZAS)',
    desc: 'El sistema para convertir datos caóticos en decisiones claras. Sin ser contador. Sin saber Excel avanzado. Con la IA como tu analista personal disponible las 24 horas.',
    includes: 'Incluye: 10 prompts de análisis financiero, Tablero de Decisión mensual, análisis anti-inflación argentino y Biblioteca de Análisis por Industria.'
  }, {
    num: 5,
    title: 'MAQUINARIA DE VENTAS (COPYWRITING Y PERSUASIÓN)',
    desc: 'El sistema completo de propuestas que ganan, guiones de cierre y manejo de objeciones calibrado para el comprador argentino escéptico. El fin de las propuestas ignoradas.',
    includes: 'Incluye: Las 8 secciones de la propuesta irrechazable, 10 guiones de cierre para WhatsApp y teléfono, 8 prompts de manejo de objeciones y Landing Pages que convierten.'
  }, {
    num: 6,
    title: 'PROYECTOS Y PLANIFICACIÓN (EL CEREBRO EXTERNALIZADO)',
    desc: 'El sistema para que tu negocio funcione sin que estés vos en cada decisión. Gestión de proyectos, planificación estratégica y toma de decisiones con IA. El fin del caos operativo.',
    includes: 'Incluye: Gestión de proyectos con IA, Plan de 90 Días, Framework de Decisión en 6 pasos, Sistema de Delegación Inteligente y Protocolo Semanal Estratégico.'
  }];
  const features = ['Prompts listos para usar desde el minuto uno', 'Checklists visuales y plantillas completables', 'Lenguaje simple, directo y sin teoría innecesaria', 'Adaptado 100% a la realidad argentina', 'Casos reales de profesionales argentinos que ya lo implementaron'];
  return <SectionWrapper className="bg-dark-card/20" data-id="element-260">
      <div className="text-center mb-16" data-id="element-261">
        <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-262">
          📚 6 TOMOS COMPLETOS
        </h2>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mb-16" data-id="element-263">
        {tomosData.map(t => <div key={t.num} className="bg-dark-card border border-dark-border rounded-2xl p-6 hover:border-primary/50 transition-colors group" data-id="element-264">
            <div className="flex items-center gap-4 mb-4" data-id="element-265">
              <div className="w-12 h-12 bg-primary/10 text-primary rounded-xl flex items-center justify-center font-black text-xl group-hover:bg-primary group-hover:text-dark-bg transition-colors shrink-0" data-id="element-266">
                T{t.num}
              </div>
              <div data-id="element-267">
                <h3 className="text-sm text-cyan-200/70 font-bold tracking-wider" data-id="element-268">
                  TOMO {t.num}
                </h3>
                <p className="text-base font-bold text-white leading-tight" data-id="element-269">
                  {t.title}
                </p>
              </div>
            </div>
            <p className="text-cyan-50/80 text-sm leading-relaxed mb-3" data-id="element-270">
              {t.desc}
            </p>
            <p className="text-cyan-200/70 text-xs leading-relaxed border-t border-dark-border pt-3" data-id="element-271">
              {t.includes}
            </p>
          </div>)}
      </div>

      <div className="max-w-3xl mx-auto bg-dark-card border border-dark-border rounded-2xl p-8 shadow-xl" data-id="element-272">
        <h3 className="text-2xl font-bold text-white mb-6 text-center" data-id="element-273">
          Cada tomo incluye:
        </h3>
        <div className="grid md:grid-cols-2 gap-4" data-id="element-274">
          {features.map((feat, i) => <div key={i} className="flex items-start gap-3" data-id="element-275">
              <CheckCircle2Icon className="text-primary shrink-0 mt-0.5" size={20} data-id="element-276" />
              <span className="text-cyan-50/90 text-sm md:text-base" data-id="element-277">
                {feat}
              </span>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
};
export const Bonuses = () => {
  const bonuses = [{
    num: '01',
    title: 'Kit de Primeros Auxilios con IA — 15 prompts de emergencia para resolver tareas urgentes hoy',
    val: '$9.000'
  }, {
    num: '02',
    title: 'Checklist Anti-Caos de la Jornada Argentina — El sistema de 3 momentos para ordenar tu día en 5 minutos',
    val: '$8.000'
  }, {
    num: '03',
    title: 'Banco de Prompts Express — 50 prompts listos para mails, WhatsApp y mensajes difíciles',
    val: '$9.000'
  }, {
    num: '04',
    title: 'Mini Guía IA para Ganar Tiempo Hoy — Las 20 tareas exactas que podés acelerar con IA desde hoy',
    val: '$8.000'
  }, {
    num: '05',
    title: 'Plantilla Maestra de Pedidos Perfectos — El sistema de 6 elementos para obtener respuestas excelentes siempre',
    val: '$9.000'
  }, {
    num: '06',
    title: 'Plan 7 Días para Empezar a Usar IA Sin Abrumarte — Tu hoja de ruta de implementación gradual',
    val: '$8.000'
  }];
  return <SectionWrapper className="bg-dark-bg" data-id="element-278">
      <div className="text-center mb-16" data-id="element-279">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-accent/15 text-accent rounded-full mb-6 ring-1 ring-accent/30" data-id="element-280">
          <GiftIcon size={32} data-id="element-281" />
        </div>
        <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-282">
          🎁 6 BONOS ESTRATÉGICOS
        </h2>
        <p className="text-2xl text-accent font-bold tracking-widest uppercase" data-id="element-283">
          Siempre incluidos
        </p>
      </div>

      <div className="max-w-4xl mx-auto mb-12" data-id="element-284">
        <div className="overflow-x-auto rounded-xl border border-accent/20 shadow-xl" data-id="element-285">
          <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-286">
            <thead data-id="element-287">
              <tr className="bg-dark-card border-b border-accent/20" data-id="element-288">
                <th className="p-4 text-sm font-bold text-accent uppercase w-16 text-center" data-id="element-289">
                  #
                </th>
                <th className="p-4 text-sm font-bold text-white uppercase" data-id="element-290">
                  Bono
                </th>
                <th className="p-4 text-sm font-bold text-cyan-200/70 uppercase text-right" data-id="element-291">
                  Valor
                </th>
              </tr>
            </thead>
            <tbody data-id="element-292">
              {bonuses.map(b => <tr key={b.num} className="border-b border-dark-border/50 hover:bg-dark-card/50 transition-colors" data-id="element-293">
                  <td className="p-4 text-accent font-black text-xl text-center align-top" data-id="element-294">
                    {b.num}
                  </td>
                  <td className="p-4 text-white font-medium" data-id="element-295">{b.title}</td>
                  <td className="p-4 text-right whitespace-nowrap align-top" data-id="element-296">
                    <span className="text-cyan-200/50 line-through mr-2" data-id="element-297">
                      {b.val}
                    </span>
                    <span className="text-primary font-bold" data-id="element-298">→ GRATIS</span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      <div className="max-w-2xl mx-auto text-center bg-accent/10 border border-accent/30 rounded-2xl p-8" data-id="element-299">
        <p className="text-cyan-50/80 text-lg mb-2" data-id="element-300">Valor total bonos</p>
        <p className="text-3xl md:text-4xl font-black text-white" data-id="element-301">
          <span className="text-cyan-200/50 line-through mr-4" data-id="element-302">$51.000</span>
          <span className="text-accent" data-id="element-303">→ GRATIS con tu SUPERKIT IA</span>
        </p>
      </div>
    </SectionWrapper>;
};